import React from "react";

import "reactjs-popup/dist/index.css";
import "./ConversationSearch.scss";

const ConversationSearch = ({ searchingByTerm }) => {

  return (
    <div className="search-container">
      <input
        type="text"
        placeholder="Pesquisar conversa"
        onChange={(e) => {
          searchingByTerm(e.target.value);
        }}
      />
    </div>
  );
};

export default ConversationSearch;
